const config = {
    build_number: '616622',
    build_timestamp: '2026-10-05T19:46:48.609Z',
    build_commit: '3805de5f87bbe10ca411273fb0c66279de69b884',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
